import { Injectable } from '@angular/core';
import { CanMatch, Route, UrlSegment } from '@angular/router';
import { map, Observable } from 'rxjs';
import { SessionService } from '../services/session.service';

@Injectable({
  providedIn: 'root'
})
export class AquilaRouteMatcher implements CanMatch {

  constructor(private session: SessionService) { }

  canMatch(route: Route, segments: UrlSegment[]): boolean {
    // might wait for an API call
    const companyId = this.session.getToken()?.companyId || NaN;
    if(companyId === 47275 // Aquila Test 
      || companyId === 39466 // Aquila Prod 
      || companyId === 28335) // NemFlex Demo 
      return true;
    return false;
  }
}
